import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc0368f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container menu__items" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 3,
  class: "menu__items-sub-menu"
}
const _hoisted_5 = {
  key: 1,
  class: "mobileMenu"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "mobileMenu__options"
}
const _hoisted_9 = {
  key: 1,
  class: "items-in-column"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "mobileMenu__options-sub-menu"
}
const _hoisted_12 = ["onClick"]

import { computed, inject, Ref, ref } from 'vue';
import { type RouteLocationRaw, useRoute, useRouter } from 'vue-router';
import ReviewModal from '@/components/ReviewModal/ReviewModal.vue';
import { useAppStore } from '@/store/modules/app';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';

type MenuItemType = {
  id: number;
  title: string;
  items?: { id: number; title: string; href?: string }[];
  clickHandler?: () => void;
  href?: RouteLocationRaw;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const showReviewModal = ref(false);
const activeMenuId: Ref<number | undefined> = ref(undefined);

const windowWidth = computed((): number => {
  return useAppStore().window;
});

const menuItems: Ref<MenuItemType[]> = ref([
  {
    id: 1,
    title: 'Популярные объявления',
    clickHandler: () => showPopularityOffers(),
  },
  {
    id: 2,
    title: 'Застройщики',
    href: { name: 'developerCards' },
  },
  {
    id: 3,
    title: 'Поселки',
    href: { name: 'residentialComplexCards' },
  },
  {
    id: 4,
    title: 'Сервисы',
    href: {
      name: 'services',
    },
  },
  {
    id: 5,
    title: 'Ипотека',
    href: { name: 'mortgage' },
  },
  {
    id: 6,
    title: 'Отзыв / предложение',
    clickHandler: () => {
      showReviewModal.value = true;
    },
  },
]);
const isMenuOpen = ref(false);

const clickOutside = () => {
  isMenuOpen.value = false;
};

const route = useRoute();
const router = useRouter();

const mainPage = computed((): boolean => {
  return route.name === 'main';
});

const clickOutSize = () => {
  activeMenuId.value = undefined;
};
const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;
const showPopularityOffers = async () => {
  useOfferCardsStore().returnToInitialState();
  useOfferCardsStore().updateSortParam('popularityDown');
  await router.push({ name: 'main' });
  await router.replace({ query: undefined });
  useOfferCardsStore().showResultBlock();

  const myEl = document.getElementById('offerCardsList');

  if (myEl) {
    smoothScroll({
      scrollTo: myEl,
      offset: 0,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (windowWidth.value > 600)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{ translucent: mainPage.value }, "menu"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menuItem) => {
              return (_openBlock(), _createElementBlock("span", {
                key: menuItem.id,
                class: "relative"
              }, [
                (menuItem.href)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: menuItem.href,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (activeMenuId.value = undefined))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menuItem.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (menuItem.items)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (activeMenuId.value = menuItem.id), ["stop"])
                      }, _toDisplayString(menuItem.title), 9, _hoisted_2))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: menuItem.clickHandler
                      }, _toDisplayString(menuItem.title), 9, _hoisted_3)),
                (activeMenuId.value === menuItem.id)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.items, (subMenuItem) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: subMenuItem.id,
                          to: { name: subMenuItem.href },
                          class: "menu__items-sub-menu-item",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeMenuId.value = undefined))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(subMenuItem.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ])), [
                      [_directive_click_outside, clickOutSize]
                    ])
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 2))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass([{ open: isMenuOpen.value }, "mobileMenu-btn"]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
          }, _hoisted_7, 2),
          (isMenuOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menuItem) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: menuItem.id,
                    class: "relative",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (isMenuOpen.value = false))
                  }, [
                    (menuItem.href)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: menuItem.href
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menuItem.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (menuItem.items)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "items-in-line gap--5",
                              onClick: ($event: any) => (activeMenuId.value = menuItem.id)
                            }, [
                              ((activeMenuId.value = menuItem.id))
                                ? (_openBlock(), _createBlock(_component_base_icon, {
                                    key: 0,
                                    name: "arrow_drop_up",
                                    width: "10"
                                  }))
                                : (_openBlock(), _createBlock(_component_base_icon, {
                                    key: 1,
                                    name: "arrow_drop_down",
                                    width: "10"
                                  })),
                              _createTextVNode(" " + _toDisplayString(menuItem.title), 1)
                            ], 8, _hoisted_10),
                            ((activeMenuId.value = menuItem.id))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.items, (subMenuItem) => {
                                    return (_openBlock(), _createBlock(_component_router_link, {
                                      key: subMenuItem.id,
                                      to: { name: subMenuItem.href }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(subMenuItem.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: menuItem.clickHandler
                          }, _toDisplayString(menuItem.title), 9, _hoisted_12))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_click_outside, clickOutside]
        ]),
    _createVNode(ReviewModal, {
      "show-modal": showReviewModal.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (showReviewModal.value = false))
    }, null, 8, ["show-modal"])
  ], 64))
}
}

})